import logoImage from '../masjid-logo.jpeg';
import './Logo.css'

export const Logo = () => (
    <div className="app-logo">
    <img src={logoImage} alt="Logo" height="auto" id="image-section" />
  </div>
  );